import createComponent, { ComponentProps } from '../utils/createComponent';
export type ModalFooterProps = ComponentProps;

const ModalFooter = createComponent({ name: 'ModalFooter' });

export default ModalFooter;
